// extracted by mini-css-extract-plugin
export default {"content":"companylayout_content__ecW5I","bgWave":"companylayout_bgWave__ykUCa","title":"companylayout_title__FX-M6","footer":"companylayout_footer__Bxdiw"};